import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SidebarComponent from '../common/sidebar-component';
import WireResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import MicroWire from '../common/sidebar/micro-wire';
import { useGetWiresFromContributor } from '../../../services/wires/from-contributor-service';

export default function OtherWires({ titleMatchedWires }) {
  const { dispatch } = React.useContext(WireResultsContext);
  const profiles = React.useMemo(() => _.map(titleMatchedWires, 'profile.id'), [titleMatchedWires]);
  const excludeWires = _.map(titleMatchedWires, 'id');
  const [{ data }, executeQuery] = useGetWiresFromContributor(_.first(profiles), excludeWires, 3);

  React.useEffect(() => {
    if (_.every(profiles, p => p === profiles[0])) {
      executeQuery();
    }
  }, [executeQuery, profiles]);

  React.useEffect(() => {
    if (_.get(data, 'wires.length')) {
      dispatch({ type: 'setOtherWires', payload: data.wires });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'wires.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.wires.length > 1 ? 'other wires' : 'another wire'} published by`}
        query={titleMatchedWires[0].profile.name}
      />
      {data.wires.map(wire => <MicroWire key={`wire-${wire.id}`} wire={wire} />)}
    </SidebarComponent>
  );
}

OtherWires.propTypes = {
  titleMatchedWires: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    profile: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};
